// Leaving the ExperimentLoader component commented for future experiments

// import * as dsLandingPageExperiment from '../experiments/car-stc-ds_landing_page_abc_test';
import { ExperimentConfig } from '../experiments';
import WithExperiment from './WithExperiment';

type ExperimentLoaderProps = {
  children: React.ReactElement;
};

/**
 * ExperimentLoader component that conditionally loads experiments
 */
const sampleImportedExperiment = {} as ExperimentConfig;
const _ExperimentLoader = ({ children }: ExperimentLoaderProps) => {
  const experiments: ExperimentConfig[] = [sampleImportedExperiment];

  // Compose experiments from right to left (inside to outside)
  // This wraps children with each experiment in reverse order
  return experiments.reduceRight(
    (wrappedContent, experiment) => (
      <WithExperiment {...experiment}>{wrappedContent}</WithExperiment>
    ),
    children
  );
};

const ExperimentLoader = ({ children }: ExperimentLoaderProps) => children;

export default ExperimentLoader;
